<nav class="subnav">
  <ul class="nav">
    <li class="nav-item">
      <a class="nav-link active" [routerLink]="['/persons/overview']">Zur Übersicht</a>
    </li>
  </ul>
</nav>

<main *ngIf="person">
  <h2>PHM PPS  <cds-icon shape="two-way-arrows"></cds-icon>  Personendetails <cds-icon shape="two-way-arrows"></cds-icon> {{ personId }}</h2>
  <button *ngIf="!person.active" class="btn btn-warning">PASSIV!</button>
  <div class="clr-row" >
    <div class="clr-col-6">
      <div class="card">
        <div class="card-header">
          Person <cds-icon shape="two-way-arrows"></cds-icon>  {{ person.firstname }} {{ person.lastname }}
        </div>
        <div class="card-block">
          <div class="card-text">
            <table class="table table-vertical">
              <tbody>
              <tr>
                <th>PPS-ID</th>
                <td>{{ person.pid }}</td>
              </tr>
              <tr *ngIf="crmMode">
                <th>CRM-ID</th>
                <td>
                  <span>{{ crmId || '-' }}</span>
                  <span *ngIf="crmIdStatus" class="label label-sm"> {{ crmIdStatus }}</span>
                </td>
              </tr>
              <tr>
                <th>Vorname</th>
                <td>{{ person.firstname }}</td>
              </tr>
              <tr>
                <th>Nachname</th>
                <td>{{ person.lastname }}</td>
              </tr>
              <tr>
                <th>Position</th>
                <td>{{ person.position }}</td>
              </tr>
              <!--<tr *ngIf="person.birthday != 0">
                <th>Geburtstag</th>
                <td>{{ person.birthday | date:'dd.MM.yyyy'  }}</td>
              </tr>-->
              <tr>
                <th>Adresse</th>
                <td>{{ person.street }}<br>{{ person.postcode }} {{ person.city }}</td>
              </tr>
              <tr>
                <th>Bundesland</th>
                <td>{{ person.region }}</td>
              </tr>
              <tr>
                <th>Telefon</th>
                <td nowrap (click)="makeACall = true; callTarget = person.phone">{{ person.phone }}</td>
              </tr>
              <tr>
                <th>Mobile</th>
                <td nowrap (click)="makeACall = true; callTarget = person.mobile">{{ person.mobile }}</td>
              </tr>
              <tr>
                <th>E-Mail</th>
                <td>{{ person.email }}<span *ngIf="person.email2"><br /> {{ person.email2 }}</span><span *ngIf="person.email3"><br /> {{ person.email3 }}</span></td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="card-footer">
          <button *ngIf="!devMode" class="btn btn-sm btn-link" [routerLink]="['/person/update', person.pid ]">Bearbeiten</button>
          <button *ngIf="!devMode" class="btn btn-sm btn-link" (click)="deletePerson(person.cid, person.pid, person.firstname, person.lastname)">Löschen</button>
        </div>
      </div>
    </div>
    <div class="clr-col-6">
      <div class="card" *ngIf="crmMode">
        <div class="card-header">
          CRM Sync
        </div>
        <div class="card-block">
          <div class="card-text">
            <table class="table table-vertical">
              <tbody>
              <tr>
                <th>Status</th>
                <td><span [class]="crmCompareClass">{{ crmCompareLabel }}</span></td>
              </tr>
              <tr>
                <th>CRM-ID</th>
                <td>{{ crmCompare?.crm_id ?? person.crm_id ?? '-' }}</td>
              </tr>
              <tr>
                <th>Sync-State</th>
                <td>{{ crmCompare?.crm_sync_state ?? person.crm_sync_state ?? '-' }}</td>
              </tr>
              <tr>
                <th>Letzter Sync</th>
                <td>{{ crmCompare?.crm_sync_at ?? person.crm_sync_at ?? '-' }}</td>
              </tr>
              <tr>
                <th>Fehler</th>
                <td>{{ crmCompare?.crm_sync_error ?? person.crm_sync_error ?? '-' }}</td>
              </tr>
              <tr>
                <th>Compare Fehler</th>
                <td>{{ crmCompare?.compare_error ?? '-' }}</td>
              </tr>
              <tr>
                <th>Blocking Issues</th>
                <td>
                  <span *ngIf="!crmCompare?.blocking_issues?.length">-</span>
                  <span *ngFor="let issue of crmCompare?.blocking_issues" class="label label-sm label-danger">{{ issue }}</span>
                </td>
              </tr>
              <tr *ngIf="crmCompare?.diffs?.length">
                <th>Feldvergleich</th>
                <td>
                  <table class="table table-compact">
                    <thead>
                    <tr>
                      <th>Feld</th>
                      <th>PPS</th>
                      <th>CRM</th>
                      <th>Status</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let diff of crmCompare?.diffs">
                      <td>{{ getDiffFieldLabel(diff.field) }}</td>
                      <td>{{ diff.pps || '-' }}</td>
                      <td>{{ diff.crm || '-' }}</td>
                      <td>
                        <span [class]="diff.equal ? 'label label-sm label-success' : 'label label-sm label-danger'">
                          {{ diff.equal ? 'gleich' : 'abweichend' }}
                        </span>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              </tbody>
            </table>
            <div>
              <br>
              <button class="btn btn-sm btn-primary" (click)="syncCrmNow()" [disabled]="crmSyncRunning || crmCompareLoading">
                {{ crmSyncRunning ? 'Synchronisiere...' : 'Jetzt synchronisieren' }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <app-contact-card [childMessage]="person.cid" ></app-contact-card>
      <app-project-card [companyId]="person.cid" [active]="person.active" [projectId]="'0'" [employeeLeader]="personId"></app-project-card>
    </div>
  </div>
</main>

<clr-modal *ngIf="person" [(clrModalOpen)]="makeACall" [clrModalStaticBackdrop]="false">
  <h3 class="modal-title">Möchten Sie {{ person.firstname }} {{ person.lastname }} anrufen?</h3>
  <div class="modal-body">
    <p><a [attr.href]="callUrl(callTarget)">{{ callTarget }}</a></p>
    <small>(Anruf wird an Telefonanlage übergeben)</small>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline" (click)="makeACall = false">Abbrechen</button>
    <button type="button" class="btn btn-primary" (click)="startCall(callTarget)">JETZT ANRUFEN</button>
  </div>
</clr-modal>
